module.exports = "<p>\r\n  view-reload works!\r\n</p>\r\n"